import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "pl-3 font-bold text-xl" }, "Core Values", -1)
const _hoisted_2 = { class: "shadow-base rounded-3xl w-[18rem] my-2 mx-2" }
const _hoisted_3 = { class: "bg-light-gray-100 flex justify-center items-center h-[170px] rounded-t-3xl" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "font-bold flex text-left pl-10 mt-2" }
const _hoisted_6 = ["innerHTML"]

import { IonSlides, IonSlide } from "@ionic/vue"

  interface Details {
    image: string
    label: string
    description: string
  }

  interface Props {
    coreData: Details[]
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CoreValue',
  props: {
    coreData: null
  },
  setup(__props: any) {

const props = __props as {
    coreData: Details[]
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_unref(IonSlides), null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.coreData, (core) => {
          return (_openBlock(), _createBlock(_unref(IonSlide), {
            key: `${core}_id`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: core.image,
                    alt: ""
                  }, null, 8, _hoisted_4)
                ]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(core.label), 1),
                _createElementVNode("p", {
                  class: "font-normal text-sm opacity-70 text-left pl-10 pb-10",
                  innerHTML: core.description
                }, null, 8, _hoisted_6)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})